module.exports = __webpack_public_path__ + "img/5d3d811.jpg";